import { computed } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import { get } from '@utils/api';
import useFetch from './api/useFetch';

/**
 * * Fetches hexa items
 * @param {ProductId} [productId]
 * @returns {Pick<import('@composables/api/useFetch').FetchApi<HexaItem[]>, "fetch" | "result">}
 */
const useHexa = createSharedComposable((productId) => {
  const url = `https://rc.hexa3d.io/product/resources?rid=205&sn=${productId}`;
  const { fetch, result } = useFetch(() => {
    // If productId could be undefined, we need to return a promise that resolves to an empty array
    if (productId === undefined) return Promise.resolve([]);
    return get(url);
  });

  return { fetch, result: computed(() => result.value || []) };
});

export default useHexa;
